import { render, staticRenderFns } from "./PerformanceMenu.vue?vue&type=template&id=60d1a69a&scoped=true"
import script from "./PerformanceMenu.vue?vue&type=script&lang=js"
export * from "./PerformanceMenu.vue?vue&type=script&lang=js"
import style0 from "./PerformanceMenu.vue?vue&type=style&index=0&id=60d1a69a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d1a69a",
  null
  
)

export default component.exports